import { fork } from 'redux-saga/effects';
import submitBulkBlockingSlotsSaga from './submitBulkBlockingSlotsSaga';

export default [fork(submitBulkBlockingSlotsSaga)];
